import { MdArrowForward } from 'react-icons/md';
import { t } from '../../utils/i18n';
import parentsImage from '../../assets/landing/parent-child-routine.jpg';
import sittersImage from '../../assets/landing/nanny-child-activity.jpg';

const CARDS = [
  { key: 'parents', image: parentsImage, tone: 'cream', action: 'find' },
  { key: 'sitters', image: sittersImage, tone: 'pink', action: 'register' },
];

const ITEMS = ['item1', 'item2', 'item3'];

export default function BenefitsSection({ onOpenAuth, onFindSitter }) {
  return (
    <section id="benefits" className="landing-section">
      <div className="landing-container">
        <header className="landing-audience-header">
          <h2 className="landing-section-title">{t('landing.benefits.sectionTitle')}</h2>
        </header>

        <div className="landing-audience-grid">
          {CARDS.map(({ key, image, tone, action }) => {
            const prefix = `landing.benefits.${key}`;
            return (
              <article
                key={key}
                className={`landing-audience-card landing-audience-card--${tone}`}
              >
                <div className="landing-audience-media">
                  <img
                    src={image}
                    alt={t(`${prefix}.imageAlt`)}
                    loading="lazy"
                    width="800"
                    height="520"
                  />
                </div>
                <div className="landing-audience-body">
                  <h3 className="landing-audience-title">{t(`${prefix}.cardTitle`)}</h3>
                  <p className="landing-audience-desc">{t(`${prefix}.description`)}</p>
                  <ul className="landing-audience-benefits">
                    {ITEMS.map((item) => (
                      <li key={item}>{t(`${prefix}.${item}`)}</li>
                    ))}
                  </ul>
                  <button
                    type="button"
                    onClick={() => (action === 'find' ? onFindSitter?.() : onOpenAuth?.('register'))}
                    className="landing-audience-cta"
                  >
                    {t(`${prefix}.cta`)}
                    <MdArrowForward aria-hidden="true" />
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
